// extracted by mini-css-extract-plugin
export default {"absoluteDivStyles":"styles-module__absoluteDivStyles__Qzf1B"};